import React, { useEffect, useState } from "react";
import "./verifyCodeSMS.css";

//Assets
import ImgRunner from "../../assets/images/runningImg.webp";
import LogoRadaria from "../../assets/images/logotipos/RADARIA-LOGOTIPO01.png";
import FormCode from "./FormCode/FormCode.jsx";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading/Loading.jsx";

const VerifyCodeSMS = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Previene el retroceso
    const handleBackButton = (e) => {
      e.preventDefault();
      navigate("/verifyCode", { replace: true });
    };

    // Agrega el estado actual al historial
    window.history.pushState(null, "", window.location.pathname);

    // Agrega el event listener
    window.addEventListener("popstate", handleBackButton);

    // Limpieza al desmontar el componente
    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [navigate]);

  return (
    <div className="container-fluid d-flex bg-black">
      <Loading loading={loading} />
      <section className="container-narrow ">
        <h2 className="text-info fs-2">
          Fomentamos un entorno que inspira y motiva a los corredores a alcanzar
          sus objetivos y superar sus límites.
        </h2>
      </section>
      <section className="conatiner-narrow-code">
        <a href="/">
          <img src={LogoRadaria} alt="LogoRadaria" width={300} />
        </a>
        <FormCode loading={loading} setLoading={setLoading} />
        <img src={ImgRunner} width={300} alt="Running Person" />
      </section>
    </div>
  );
};

export default VerifyCodeSMS;
